// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025

import FixedDepositActionTypes from './fixed-deposit.types';

/** ***************** GET FIXED DEPOSIT DETAILS START *********************** */
export const getFixedDepositDetailsStart = (getData: any) => ({
	type: FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_START,
	payload: getData,
});

export const getFixedDepositDetailsSuccess = (successData: any) => ({
	type: FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_SUCCESS,
	payload: successData,
});

export const getFixedDepositDetailsFailure = (failureData: any) => ({
	type: FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_FAILURE,
	payload: failureData,
});

export const getFixedDepositDetailsResponseResetStart = () => ({
	type: FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET,
});

export const getFixedDepositDetailsResponseChanged = () => ({
	type: FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET FIXED DEPOSIT DETAILS END *********************** */

/** ***************** ADD FIXED DEPOSIT DETAILS START *********************** */
export const addFixedDepositDetailsStart = (getData: any) => ({
	type: FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_START,
	payload: getData,
});

export const addFixedDepositDetailsSuccess = (successData: any) => ({
	type: FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_SUCCESS,
	payload: successData,
});

export const addFixedDepositDetailsFailure = (failureData: any) => ({
	type: FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_FAILURE,
	payload: failureData,
});

export const addFixedDepositDetailsResponseResetStart = () => ({
	type: FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET,
});

export const addFixedDepositDetailsResponseChanged = () => ({
	type: FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD FIXED DEPOSIT DETAILS END *********************** */

/** ***************** DELETE FIXED DEPOSIT DETAILS START *********************** */
export const deleteFixedDepositDetailsStart = (getData: any) => ({
	type: FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_START,
	payload: getData,
});

export const deleteFixedDepositDetailsSuccess = (successData: any) => ({
	type: FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteFixedDepositDetailsFailure = (failureData: any) => ({
	type: FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteFixedDepositDetailsResponseResetStart = () => ({
	type: FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET,
});

export const deleteFixedDepositDetailsResponseChanged = () => ({
	type: FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE FIXED DEPOSIT DETAILS END *********************** */

/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE DETAILS START *********************** */
export const fetchFixedDepositCollectionApproveDetailsStart = (getData: any) => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_START,
	payload: getData,
});

export const fetchFixedDepositCollectionApproveDetailsSuccess = (successData: any) => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchFixedDepositCollectionApproveDetailsFailure = (failureData: any) => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchFixedDepositCollectionApproveDetailsResponseResetStart = () => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_RESPONSE_RESET,
});

export const fetchFixedDepositCollectionApproveDetailsResponseChanged = () => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE DETAILS END *********************** */

/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS START *********************** */
export const fetchFixedDepositCollectionApproveEodDetailsStart = (getData: any) => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_START,
	payload: getData,
});

export const fetchFixedDepositCollectionApproveEodDetailsSuccess = (successData: any) => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchFixedDepositCollectionApproveEodDetailsFailure = (failureData: any) => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchFixedDepositCollectionApproveEodDetailsResponseResetStart = () => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_RESPONSE_RESET,
});

export const fetchFixedDepositCollectionApproveEodDetailsResponseChanged = () => ({
	type: FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS END *********************** */
